// extracted by mini-css-extract-plugin
export default {"bell_div":"styles_bell_div__GSfOG","red_div":"styles_red_div__hHRiS","text":"styles_text__YBgQl"};